import _taggedTemplateLiteral from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        @media (min-width: ", "rem) {\n          margin: -", " 0 0 -", ";\n\n          & > div {\n            padding: ", " 0 0 ", ";\n          }\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          margin: -", " 0 0 -", ";\n\n          & > div {\n            padding: ", " 0 0 ", ";\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &&:not([hidden]) {\n      display: block;\n    }\n\n    & > div:not([hidden]) {\n      display: inline-block;\n    }\n\n    & > div {\n      vertical-align: middle;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';

function rem(px) {
  return "".concat(px / 16, "rem");
}

export function inlineBaseStyles() {
  return css(_templateObject());
}
export function inlineSpaceStyles(props) {
  var theme = props.theme;
  return css(_templateObject2(), props.space.map(function (spaceIndex, mqIndex) {
    var space = rem(theme.sanity.space[spaceIndex]);
    if (mqIndex === 0) return css(_templateObject3(), space, space, space, space);
    return css(_templateObject4(), theme.sanity.media[mqIndex - 1] / 16, space, space, space, space);
  }));
}